import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IClient } from "@ontime/types";
import { selectSelectedOrganization } from '../../stateManagement/selectedOrganizationSlice';
import ClientService from '../../services/ClientService';
import { CircularProgress, Dialog, DialogTitle, DialogContent, Typography, IconButton, Box } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import LaunchIcon from '@mui/icons-material/Launch';
import ClientForm from './ClientForm';
import InfoComponent from '../../customComponents/InfoComponent';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

const ClientName: React.FC<{ clientId?: string;showdetail?: boolean;  }> = ({ clientId,showdetail=true }) => {
    const organization = useSelector(selectSelectedOrganization);

    const [client, setClient] = useState<IClient | undefined>();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const fetchClient = async () => {
        if (clientId && organization.organizationId) {
            setLoading(true);
            try {
                const response = await ClientService.Get(organization.organizationId, clientId);
                setClient(response);
            } catch (error) {
                console.error(error, { variant: 'error' });
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchClient();
    }, [organization.organizationId, clientId]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            {loading ? (
                <CircularProgress size={20} sx={{ ml: 1 }} />
            ) : (
                <Box  display='flex'>
                    <AssignmentIndIcon />
                    <Typography variant="body1" gutterBottom>
                {`${client?.firstName ?? ''}${client?.lastName ? ` ${client?.lastName}` : ''}`}
                </Typography>
                {showdetail && 
                 <InfoComponent infoContent='Show detail client'>
                <IconButton
                    aria-label="view-client"
                    size="small"
                    onClick={handleOpen}
                    
                >
                    <LaunchIcon fontSize="small" />
                </IconButton>
                </InfoComponent>}
                </Box>
            )}

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                {editMode ? (
                    <ClientForm
                        clientInput={client}
                        closeForm={(updated) => {
                            if (updated) setClient(updated);
                            setEditMode(false);
                        }}
                        handleSetClient={(updated) => setClient(updated ?? undefined)}
                    />
                ) : (
                    <>
                        <DialogTitle>
                            Client Details
                            <IconButton
                                aria-label="edit"
                                size="small"
                                onClick={() => setEditMode(true)}
                                sx={{ ml: 1 }}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent dividers>

                            <>
                                <Typography><strong>Full Name:</strong> {client?.firstName} {client?.lastName}</Typography>
                                <Typography><strong>Phone:</strong> {client?.phone}</Typography>
                                <Typography><strong>Email:</strong> {client?.email}</Typography>
                                <Typography><strong>Gender:</strong> {client?.gender}</Typography>
                                <Typography><strong>Date of Birth:</strong> {client?.dateOfBirth && new Date(client?.dateOfBirth).toLocaleDateString()  }</Typography>
                                <Typography><strong>Referral:</strong> {client?.referralFullName}</Typography>
                                <Typography><strong>Code:</strong> {client?.code}</Typography>
                                <Typography><strong>Note:</strong> {client?.note}</Typography>
                            </>

                        </DialogContent>
                    </>
                )}
            </Dialog>
        </>
    );
};

export default ClientName;